import React, { Component } from 'react'
import { getInformationWithData, getInformationWithDataB1, getInformationWithDataV3 } from '../services/CABE.js' // getInformationWithDataV3 added CUSTFIX-2026-09-16
import LoadingWindow from '../components/LoadingWindow';
import { getValueCookie } from '../services/cookieService.js';
import { BsArrowRepeat } from "react-icons/bs";
import { AiOutlineFileText } from "react-icons/ai";
import { ActualDate, DateFormatMAS90 } from '../functions/dateFormat.js';
import { getPriceMargin, getPurePriceMargin, intervalTimeInDays, NumberFormat } from '../functions/generalFunctions.js';
import { confirmCloseAlert } from '../functions/alerts.js';
import { getIndexElement } from '../functions/searchInObject.js';
import { pricesFormat } from '../functions/pricesFormat.js';
import ModalOrders from './ModalComponent.js';
import "../css/table-responsive.css"

export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }
    state = {
        salesOrderList: [],
        salesOrderListFilter: []
    }

    async getSalesOrderHeader(refresh) {
        await this.handleModalOpen()
        const data = {
            SalespersonNo: getValueCookie('SalesPerson'),
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
        }
        const data2 = {
            idcompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            SalespersonNo: '0000'
        }


        const buscador = document.getElementById('salesorder_busqueda_' + this.props.nombrePadre);

        if (refresh || this.state.salesOrderList.length <= 0) {
            this.ModalLoading.current.showState(true);
            this.setState({ salesOrderList: [], salesOrderListFilter: [] });

            const respuesta = await getInformationWithData('/sales/get/header', data);

            const completeList = await getInformationWithData('/sales/get/header/byDate', data2);

            if (respuesta.status.code === 1) {
                let result = respuesta.data
                for (const sale of result) {
                    const pos = getIndexElement(completeList.data, 'SalesOrderNo', sale.SalesOrderNo)
                    sale.PosQue = pos !== -1 ? (completeList.data[pos].posicion ? (completeList.data[pos].posicion) : 999) : 999
                    if (sale.OrderType === 'S') {
                        sale.TypeinLetters = 'Standard'
                    } else {
                        sale.TypeinLetters = 'Quote'
                    }
                }

                await this.setState({ salesOrderList: result, salesOrderListFilter: result });

            }
            this.ModalLoading.current.showState(false);
        }
        await this.setState({ salesOrderListFilter: this.state.salesOrderList });
        buscador.value = '';
        setTimeout(() => { buscador.focus(); }, 300);

    }

    async getSalesOrder(SalesOrderHeader) {
        //Aqui asignamos el producto al estado del padre
        const SalesOrderStatus = SalesOrderHeader.Status;
        await this.handleModalClose()
        let state = 0
        if (SalesOrderHeader.OrderType === 'S') {
            state = 'S'
            this.props.Padre.setState({isNotNewSO: true})
        } else {
            state = 'Q'
            this.props.Padre.setState({isNotNewSO: false})
        }
        if (!(SalesOrderHeader.Status)) {
            SalesOrderHeader.Status = 0
        }

        let enableEdit = false
        
        if (getValueCookie('CompanyId') === '6' && SalesOrderHeader.Status !== 0) {
            
            enableEdit = true
        }

        if ((this.props.nombrePadre === 'SalesOrderListSO')) {
            SalesOrderHeader.Status = -1
        }
        let TemporalSalesOrderNo = ""
        if (SalesOrderHeader.SalesOrderNo) {
            let SalesOrderProvisonalNo = SalesOrderHeader.SalesOrderNo.split('-')
            TemporalSalesOrderNo = SalesOrderProvisonalNo.length > 1 ? SalesOrderProvisonalNo[0] : SalesOrderHeader.SalesOrderNo
        }


        const data = {
            SalesOrderNo: TemporalSalesOrderNo !== "" ? TemporalSalesOrderNo : SalesOrderHeader.SalesOrderNo,
            OrderNo: SalesOrderHeader.SalesOrderNo,
            CustomerNo: SalesOrderHeader.CustomerNo,
            username: getValueCookie('userName'),
            company: getValueCookie('Company'),
            idCompany: Number(getValueCookie('CompanyId')),
            idcompany: getValueCookie('CompanyId'),
            Mode: true,
            InvoiceType: 1,
            Status: SalesOrderHeader.Status
        }



        this.ModalLoading.current.showState(true);
        const result1 = await getInformationWithData('/sales/get/detail', data)
        const result2 = await getInformationWithData('/customer/getByCustomerNo', data)
        const balance = await getInformationWithDataB1('/customer/getBalance', data)

        const invent = await getInformationWithData('/Items/get', data)
        for (const item of invent.data) {
            item.IdCompany = 6
        }
        if (getValueCookie('CompanyId') === '6') {
            data.company = 'Mayaland Atlanta'
            data.idcompany = '3'
            const inventM = await getInformationWithData('/Items/get', data);
            invent.status.code = inventM.status.code
            for (const item of inventM.data) {
                item.IdCompany = 3
                const index = getIndexElement(invent.data, 'itemCode', item.itemCode)
                if (index !== -1) {
                    await invent.data.splice(index, 1)
                }
            }
            invent.data = invent.data.concat(inventM.data)
        }


        // ═══ CUSTFIX-2026-09-16 (inicio) ═══════════════════════════════════
        // Corrige: recargar una SO desde SO V3 (AL65218, 2026-09-15/16)
        // cambiaba el cliente a otro (Tienda La Ideal -> La Esperanza
        // Bakery) — /customer/getByCustomerNo puede traer el cliente de
        // OTRA petición si comparte la conexión WS con algo más en ese
        // instante (ver WSFIX-2026-09-16 en el backend). Esto ADEMÁS
        // reprecia toda la orden con el nivel de precio del cliente
        // equivocado (componentDidUpdate en SalesOrderV3.js reacciona a
        // cualquier cambio de Customer.CustomerNo) — así que el total
        // "raro" reportado el mismo día era consecuencia de este mismo bug,
        // no un problema aparte. Mismo patrón que SalesOrderPicking.js /
        // InvoiceListSalesPerson.js: comparamos contra (a) el cliente que
        // ya sabíamos por la propia fila de la lista de SOs y (b) el
        // respaldo en document_audit_trail grabado el día que se creó la
        // SO (nunca se vuelve a tocar). Opt-in vía
        // this.props.verifyCustomerMatch — solo SalesOrderV3.js lo manda,
        // así que SalesOrder.js/SalesOrderV2.js/PreSalesOrder.js y demás
        // páginas que usan este componente quedan exactamente igual que
        // antes.
        // Para revertir: quita "&& !customerMismatch" del if de abajo,
        // borra la declaración de customerMismatch (con su bloque de
        // document_audit_trail), y el "else if" que sigue al bloque de
        // éxito.
        let customerMismatch = !!(
            this.props.verifyCustomerMatch &&
            result2.data && result2.data[0] &&
            SalesOrderHeader.CustomerNo &&
            String(result2.data[0].CustomerNo || '').trim() !== String(SalesOrderHeader.CustomerNo).trim()
        );
        if (this.props.verifyCustomerMatch && result2.data && result2.data[0] && data.SalesOrderNo && !customerMismatch) {
            try {
                const auditCheck = await getInformationWithDataV3('/v3/audit/original-customer', {
                    docNo: data.SalesOrderNo,
                    idCompany: Number(getValueCookie('CompanyId')),
                });
                if (auditCheck && auditCheck.status && auditCheck.status.code === 1 && auditCheck.data && auditCheck.data.found) {
                    const originalCustomerNo = String(auditCheck.data.customerNo || '').trim();
                    const loadedCustomerNo = String(result2.data[0].CustomerNo || '').trim();
                    if (originalCustomerNo && originalCustomerNo !== loadedCustomerNo) {
                        customerMismatch = true;
                        console.warn(
                            '[CUSTFIX-2026-09-16] Customer mismatch vs document_audit_trail original — expected',
                            originalCustomerNo, 'got', loadedCustomerNo
                        );
                    }
                }
            } catch (auditError) {
                // Nunca bloquea la carga por esto — es un respaldo extra, no
                // la fuente principal de verdad.
                console.warn('[CUSTFIX-2026-09-16] audit/original-customer check failed (non-blocking):', auditError);
            }
        }
        if (customerMismatch) {
            console.warn(
                '[CUSTFIX-2026-09-16] Customer mismatch on Sales Order reload — expected',
                SalesOrderHeader.CustomerNo, 'got', result2.data && result2.data[0] && result2.data[0].CustomerNo
            );
        }
        // ═══ CUSTFIX-2026-09-16 (fin de la declaración) ═════════════════════
        if (result1.status.code === 1 && result2.status.code === 1 && balance.status.code === 1 && !customerMismatch) {
            const Father = this.props.Padre
            if (this.props.nombrePadre === 'SalesOrderListSO') {
                const CustomerResult = result2.data[0]
                const Packing = SalesOrderHeader.Packing ? SalesOrderHeader.Packing.split(';') : null
                const SalesOrder = {

                    Customer: {
                        AddressLine1: CustomerResult.AddressLine1,
                        City: CustomerResult.City,
                        CustomerName: CustomerResult.CustomerName,
                        CustomerNo: CustomerResult.CustomerNo,
                        EmailAddress: CustomerResult.EmailAddress,
                        PriceLevel: CustomerResult.PriceLevel,
                        SalespersonNo: CustomerResult.SalespersonNo,
                        State: CustomerResult.State,
                        TelephoneNo: CustomerResult.TelephoneNo,
                        ZipCode: CustomerResult.ZipCode,
                    },
                    NoOrder: SalesOrderHeader.SalesOrderNo,
                    Type: state,
                    TotalQuantityOrdered: 0,
                    TotalCost: 0,
                    Date: SalesOrderHeader.OrderDate,
                    Warehouse: SalesOrderHeader.WarehouseCode,
                    Packing: Packing ? (Packing.length === 2 ? Packing[0] : null) : null,
                    WeightOption: Packing ? (Packing.length === 2 ? Packing[1] : null) : null,
                    MAS90Status: SalesOrderHeader.MAS90Status,
                    Duplicate:false,
                    status: SalesOrderStatus
                }
                let Detail = []
                // Las lineas pendientes de pickear llegan en Tabla1 y las ya
                // despachadas en Tabla2. Al despacharse una linea pasa de Tabla1
                // a Tabla2 (no se duplica), por lo que unimos ambas para que una
                // orden ya despachada siga mostrando sus items.
                const detailLines = [
                    ...(result1.data.Tabla1 || []),
                    ...(result1.data.Tabla2 || [])
                ]
                detailLines.forEach(element => {

                    if (getValueCookie('CompanyId') === '6') {
                        const index = getIndexElement(invent.data, 'itemCode', element.ItemCode)
                        if (index !== -1) {
                            element.UnitCost = invent.data[index].LastTotalUnitCost
                        }
                    }

                    const index2 = getIndexElement(invent.data, 'itemCode', element.ItemCode)
                    let desc = ''
                    let LastTotalUnitCost = 0
                    let comp = 1563
                    if (index2 !== -1) {

                        desc = (!(invent.data[index2].completeDesc) || invent.data[index2].completeDesc === "null") ? invent.data[index2].abbreviatedDesc : invent.data[index2].completeDesc
                        comp = invent.data[index2].IdCompany ? invent.data[index2].IdCompany : 1563

                        LastTotalUnitCost = invent.data[index2].LastTotalUnitCost
                    } else {
                        desc = element.ItemCodeDesc
                    }

                    const indDupl = getIndexElement(Detail, 'itemCode', element.ItemCode)
                    if(indDupl!==-1&&!SalesOrder.Duplicate){
                        SalesOrder.Duplicate=true
                    }
                    const itemTemporal = {
                        BIN: "",
                        Comment: getValueCookie('CompanyId') === '6' ? "BOX: " + getPriceMargin(element.UnitPrice, element.UnitCost, SalesOrderHeader.PriceLevel) : element.CommentText,
                        PureMargin: getValueCookie('CompanyId') === '6' ? getPurePriceMargin(element.UnitPrice, element.UnitCost) : 0,
                        LastTotalUnitCost: LastTotalUnitCost,
                        ShipWeight: element.LineWeight,
                        StandardUnitCost: element.UnitCost,
                        UnitPrice: Number(element.UnitPrice).toFixed(2),
                        Visible: (element.QuantityOrdered !== 0 || element.QuantityShipped !== 0) ? 1 : 0,
                        abbreviatedDesc: desc,
                        caseupc: "",
                        itemCode: element.ItemCode,
                        quantity: 0,
                        quantityOrdered: element.QuantityOrdered,
                        LineSequence: element.LineSeqNo,
                        quantityShipped: element.QuantityShipped,
                        quantityReceived: 0,
                        totalCost: ((Number(element.QuantityOrdered) * Number(element.UnitPrice)).toFixed(2)),
                        totalFreight: 0,
                        unitCost: element.UnitCost,
                        upc: "",
                        upc2: "",
                        IdCompany: comp,
                        duplicate: indDupl !== -1 ? 'bg-danger' : '',
                        // 2026-09-16 fix — a line loaded from an EXISTING Sales
                        // Order carries its own real, already-saved UnitPrice
                        // (from element.UnitPrice above), not a fresh catalog
                        // price. Without this flag, SalesOrderV3.js's
                        // componentDidUpdate() treats every one of these lines
                        // as "not yet priced" and applyStandardPricing()
                        // silently overwrites UnitPrice with the CURRENT
                        // standard price for the customer's tier — discarding
                        // whatever was actually negotiated/saved on this order,
                        // which then gets sent as-is to /sales/set/order on the
                        // next save. See componentDidUpdate()'s own comment for
                        // the other half of this fix (priming __prevCustomerNo).
                        _pricingApplied: true,
                    }
                    Detail.push(itemTemporal)
                });

                balance.data.forEach(element => {
                    element.PaymentDelayDays = intervalTimeInDays(DateFormatMAS90(element.InvoiceDueDate), ActualDate())
                    element.InvoiceDate = DateFormatMAS90(element.InvoiceDate)
                    element.InvoiceDueDate = DateFormatMAS90(element.InvoiceDueDate)
                    element.CustomerName = CustomerResult.CustomerName
                });

                const temporalBalance = Father.state.Balance
                temporalBalance.HeaderBalance = balance.data
                temporalBalance.TermsCode = CustomerResult.TermsCodeDesc


                // 2026-09-16 fix — SalesOrderV3.js's componentDidUpdate()
                // compares the current Customer.CustomerNo against
                // Father.__prevCustomerNo (a plain instance field, not React
                // state) to detect a genuine customer change and re-price the
                // whole cart via loadPricingMap(). That field was never primed
                // when loading an EXISTING order, so it kept whatever value it
                // had before (often '' from a blank/previous order) — always
                // different from this order's real customer, so opening ANY
                // saved Sales Order looked exactly like the user manually
                // switching customers, re-running loadPricingMap() (which
                // itself resets _pricingApplied: false on every line) right on
                // top of the _pricingApplied fix above. Priming it here to the
                // order actually being loaded stops that false trigger, while
                // a REAL customer change later (via CustomerListV3) still
                // works exactly as before — Father.__prevCustomerNo only
                // matches by coincidence when it's genuinely the same customer.
                Father.__prevCustomerNo = SalesOrder.Customer.CustomerNo
                Father.setState({Products: Detail, SalesOrder: SalesOrder, Balance: temporalBalance, ConfirmSave: Detail.length,enableEdit:enableEdit })
                Father.refreshInputs()
                Father.calculateTotals()
                Father.getTotalBalance()
                Father.handleModalOpen("showModal1")

                
                if (SalesOrder.Customer.CustomerNo === '0016027' && getValueCookie('CompanyId') !== '6'){
                    Father.setState({isMayalandOrder: false})
                } else {
                    Father.setState({isMayalandOrder: true})
                }
            }

        } else if (customerMismatch && this.props.onOrderLoadFailed) {
            // CUSTFIX-2026-09-16 — opt-in, additive: only SalesOrderV3.js
            // passes onOrderLoadFailed today, so every other page using this
            // component keeps the generic "Whoops" alert below, unchanged.
            await this.props.onOrderLoadFailed(SalesOrderHeader,
                'The customer that loaded with this sales order does not match the sales order\'s own customer. This has happened before due to a data mismatch bug — do not edit/save this order. Retrying will reload it; if it happens again, contact Support before continuing.'
            );
        } else {
            confirmCloseAlert('incorrect', 'Whoops something was wrong try again please!')
        }
        this.ModalLoading.current.showState(false);

    }

    contiene(parametro, busqueda) {
        if (parametro && busqueda) {
            return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        }

    }

    searchSalesOrder = e => {

        let busqueda = e.target.value;

        if (busqueda) {
            let orders = this.state.salesOrderList.filter((order_) => {
                if (((
                    this.contiene(order_.BillToAddress1, busqueda) ||
                    this.contiene(order_.BillToName, busqueda) ||
                    this.contiene(order_.SalespersonNo, busqueda) ||
                    this.contiene(order_.SalesOrderNo, busqueda) ||
                    this.contiene(order_.TermsCode, busqueda) ||
                    this.contiene(order_.CustomerNo, busqueda) ||
                    this.contiene(order_.TypeinLetters, busqueda)
                ))
                ) {
                    return order_
                } else {
                    return null
                }
            });
            this.setState({ salesOrderListFilter: orders });
        } else {
            let temporal = this.state.salesOrderList
            this.setState({ salesOrderListFilter: temporal })
        }
    }

    stateInWords(state) {
        if (state === 1) {
            return 'In process'
        } else if (state === 2) {
            return 'Finished'
        } else {
            return 'Not started'
        }
    }
    Mas90stateInWords(state) {
        if (state === 0) {
            return 'Not Charged'
        } else if (state === 1) {
            return 'Charged'
        }
        return ''
    }

    stateColor(state) {
        if (state === 1) {
            return 'text-dark yellow'
        } else if (state === 2) {
            return 'text-light green'
        } else {
            return 'text-light red'
        }
    }
    MAS90stateColor(state) {
        if (state === 0) {
            return 'text-danger'
        } else if (state === 1) {
            return 'text-success'
        }
        return ''

    }


    handleModalOpen = async () => {
        await this.setState({ showModal: true })
    }

    handleModalClose = () => {

        this.setState({ showModal: false })
    }

    render() {
        const btnWidth = this.props.width ? `${this.props.width}%` : `100%`;

        return (
            <>
                {/* Button for SO list */}
                <button type="button" disabled={this.props.disabled} hidden={this.props.hidden} className="btn purpleButton btn-lg" onClick={() => this.getSalesOrderHeader(true)} style={{ width: btnWidth }}><AiOutlineFileText /> By SO List</button>
                
                {/* Loading modal */}
                <LoadingWindow ref={this.ModalLoading} />
                
                <ModalOrders title={'Sales Order List'} show={this.state.showModal} close={() => this.handleModalClose()}>
                    <div className='row form-group'>
                        <div className="input-group input-group-lg flex-nowrap col-sm-12 pb-3">
                            <input className='form-control w-75 display-inline' placeholder='Search by...' id={'salesorder_busqueda_' + this.props.nombrePadre} onKeyUp={this.searchSalesOrder} />
                            <span className="input-group-text">
                                <button className='btn greenButton btn-lg' onClick={() => this.getSalesOrderHeader(true)}><BsArrowRepeat /></button>
                            </span>
                        </div>
                        <div className='col-sm-12 tableFixHead'>
                            <table className='table align-middle table-hover'>
                                <thead className='table-dark text-center thead'>
                                    <tr>
                                        <th>Order No</th>
                                        <th>Type</th>
                                        <th>Status</th>
                                        {/* <th>MAS90 Status</th>*/}
                                        <th>Customer No</th>
                                        <th>Customer Name</th>
                                        <th>Sales Person</th>
                                        <th>Terms Code</th>
                                        <th>Date</th>
                                        <th>Total Amount</th>
                                        <th>Queue Position</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.salesOrderListFilter.map((element, e) => (
                                            <tr key={e} onClick={() => this.getSalesOrder(element)}>
                                                <td>{element.SalesOrderNo}</td>
                                                <td>{element.TypeinLetters}</td>
                                                <td>
                                                    <span className={'badge ' + this.stateColor(element.Status) + "Background"}>{this.stateInWords(element.Status)}</span>
                                                    </td>
                                                {/*<td className={'text-center '+this.MAS90stateColor(element.MAS90Status)}>{this.Mas90stateInWords(element.MAS90Status)}</td>*/}
                                                <td className='text-center'>{element.CustomerNo}</td>
                                                <td className='text-center'>{element.BillToName}</td>
                                                <td className='text-center'>{element.SalespersonNo}</td>
                                                <td className='text-center'>{element.TermsCode}</td>
                                                <td className='text-center'>{DateFormatMAS90(element.OrderDate)}</td>
                                                <td className='text-center'>{NumberFormat(pricesFormat(element.NonTaxableAmt))}</td>
                                                <td className='text-center'>{element.PosQue === 999 ? 'Completed' : element.PosQue}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalOrders>
            </>
        )
    }
}
